export enum DifferentiationScreenAction {
  OVERVIEW = 'OVERVIEW',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  VISIBILITY = 'VISIBILITY',
}
